export function asRecord(item) {
    return item;
}
export function asGameInfo(item) {
    return item;
}
export function asPriceItem(item) {
    return item;
}
